const tablinks = document.querySelectorAll('.tablinks');
const tabcontent = document.querySelectorAll('.tabcontent');


tablinks.forEach((tablink) => {
    tablinks[0]?.classList.add("active");
    tabcontent[0]?.classList.add("active");
    tablink.addEventListener('click', function (e) {
        document.querySelectorAll('.tabcontent').forEach((tab) => {
            tab.classList.remove("active");
        });
        tablinks.forEach((tab) => {
            tab.classList.remove("active");
        });
        e.target.classList.add("active");
        const tabName = e.target.getAttribute('data-name');
        document.getElementById(tabName).classList.add("active");
    });
})

const accordions = document.querySelectorAll('.apprenticeship-course-tabs .accordion');
const panels = document.querySelectorAll('.apprenticeship-course-tabs .panel');


accordions.forEach((accordion) => {
    accordions[0].classList.add("active");
    panels[0].classList.add("active");
    accordion.addEventListener('click', function (e) {
        e.target.classList.add("active");
        const tabName = e.target.getAttribute('data-name');
        document.getElementById(tabName).classList.add("active");
    });
});